/* -disable import/no-extraneous-dependencies */
/* -disable radix */
// NPM imports
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { groupBy } from 'lodash-es';

// Module imports
import Map from './components/Map';
import DeliveryStatus from '../../components/DeliveryStatus';

import {
  changeDeliveryStatus,
  deliveryStatusTypes,
  storeKeys,
} from '../../../../redux/delivery-status';

// Component

import './styles.css';
import { getDeliveryStatusDeliveriesByAccType } from '../../../../redux/selectors';
import { performanceStatus } from '../../../Tracking/utils/delivery-status';
import { offsetCenter } from '../../../../utils/offsetCoodinates';

// Utils

import {mapCenterCalculate} from '../../../../utils/map-center-calculate';

class DashboardRealTime extends Component {
  constructor(props) {
    super(props);
    this.state = {
      deliveryStatusActiveTab: [
        performanceStatus.ONTIME,
        performanceStatus.LATE_RISK,
        performanceStatus.LATE
      ],
      mapRef: null,
      mapCenter: {
        lat: -14.238962,
        lng: -51.913029,
      },
      mapExhibition: null,
      zoom: 5,
      activeNf: {
        isVisible: false,
        lat: 0,
        lng: 0,
        nfId: 0,
        expanded: 0,
      },
      activeRow: {},
    };
    
    
    this._setMapRef = this._setMapRef.bind(this);
    this._getPositionFromTracking = this._getPositionFromTracking.bind(this);
    this._changeTab = this._changeTab.bind(this);
    this._setActiveNf = this._setActiveNf.bind(this);
    this._getVehiclePosition = this._getVehiclePosition.bind(this);
    this._renderMarkerTooltip = this._renderMarkerTooltip.bind(this);
    this._hideMarkerTooltip = this._hideMarkerTooltip.bind(this);
    this._getNfLocationFromTable = this._getNfLocationFromTable.bind(this);
    this._changeMapExhibition = this._changeMapExhibition.bind(this);
    this._handleZoomChanged = this._handleZoomChanged.bind(this);
  }

  _setMapRef(mapRef) {
    this.setState({ mapRef });
  }

  _handleZoomChanged() {
    if (!this.state.mapRef) return;

    const newZoom = this.state.mapRef.getZoom();
    if (newZoom !== this.state.zoom) {
      this.setState({ zoom: newZoom });
    }
  }

  _getPositionFromTracking(mapRef) {
    const {
      onTime,
      lateRisk,
      late,
      onTimeFiltered,
      lateRiskFiltered,
      lateFiltered,
      deliveryData,
      match: {
        params: { id },
      },
    } = this.props;

    const allDeliveries = [...onTime, ...lateRisk, ...late];
    const allFileredDeliveries = [
      ...onTimeFiltered,
      ...lateRiskFiltered,
      ...lateFiltered,
    ];

    const selectedPosition = allDeliveries.find(el => el.nfId === parseInt(id));
    const selectedFiltered = allFileredDeliveries.find(
      el => el.id === parseInt(id),
    );

    const nfListGroup = groupBy(deliveryData, 'cpfMotorista');

    const activeRow = selectedFiltered && {
      nf: `${selectedFiltered.nf}-${selectedFiltered.nfGroup}`,
      nfValue: selectedFiltered.nfValue,
      client: selectedFiltered.destination.name,
      id: selectedFiltered.id,
    };

    if (selectedFiltered) {
      this.setState(() => ({
        activeRow,
      }));
    }

    if (selectedPosition && mapRef) {
      if (selectedPosition.trackerLocation) {
        const { latitude, longitude, landmark, time } =
          selectedPosition.trackerLocation;

        const curPosition = new window.google.maps.LatLng(latitude, longitude);
        const newCenter = offsetCenter(
          curPosition,
          mapCenterCalculate(848),
          0,
          mapRef,
        );

        this._setActiveNf({
          centerLat: newCenter.lat(),
          centerLng: newCenter.lng(),
          isVisible: true,
          lat: latitude,
          lng: longitude,
          landmark,
          lastUpdate: time,
          nfId: selectedPosition.nfId,
          data: nfListGroup[selectedFiltered.cpfMotorista],
          expanded: nfListGroup[selectedFiltered.cpfMotorista].findIndex(
            el => el.id === parseInt(id, 10),
          ),
        });

        return;
      }

      if (selectedPosition.appLocation) {
        const { latitude, longitude, landmark, time } =
          selectedPosition.appLocation;

        const curPosition = new window.google.maps.LatLng(latitude, longitude);
        const newCenter = offsetCenter(
          curPosition,
          mapCenterCalculate(848),
          0,
          mapRef,
        );

        this._setActiveNf({
          centerLat: newCenter.lat(),
          centerLng: newCenter.lng(),
          isVisible: true,
          lat: latitude,
          lng: longitude,
          landmark,
          lastUpdate: time,
          nfId: selectedPosition.nfId,
          data: nfListGroup[selectedFiltered.cpfMotorista],
          expanded: nfListGroup[selectedFiltered.cpfMotorista].findIndex(
            el => el?.id === parseInt(id, 10),
          ),
        });
      }
    }
  }

  _changeTab(type, performanceStatusCode) {
    this.setState({
      deliveryStatusActiveTab: performanceStatusCode,
    });
    this.props.dispatch(changeDeliveryStatus({ performanceStatusCode }));
  }

  _setActiveNf({
    centerLat,
    centerLng,
    isVisible,
    lat,
    lng,
    landmark,
    lastUpdate,
    nfId,
    data,
    expanded,
    zoom,
  }) {
    this.setState({
      mapCenter: {
        lat: centerLat,
        lng: centerLng,
      },
      zoom,
      activeNf: {
        isVisible,
        lat,
        lng,
        landmark,
        lastUpdate,
        nfId,
        data,
        expanded,
      },
    });
  }

  _getVehiclePosition(activeRow) {
    let newLocationList= [];
    const { onTime, lateRisk, late, deliveryData } = this.props;

    const { mapRef } = this.state;

    const locationList = [...onTime, ...lateRisk, ...late];

    locationList.map(location => {
      if (location.appLocation !== null) {
        newLocationList.push({
          companyId: location.companyId,
          nfId: location.nfId,
          performance: location.performance,
          status: location.status,
          shippingGroupId: location.shippingGroupId,
          latitude: location.appLocation.latitude,
          longitude: location.appLocation.longitude,
          landmark: location.appLocation.landmark,
          time: location.appLocation.time,
          isAppLocation: true,
        });
      }

      if (location.trackerLocation !== null) {
        newLocationList.push({
          companyId: location.companyId,
          nfId: location.nfId,
          performance: location.performance,
          status: location.status,
          shippingGroupId: location.shippingGroupId,
          latitude: location.trackerLocation.latitude,
          longitude: location.trackerLocation.longitude,
          landmark: location.trackerLocation.landmark,
          time: location.trackerLocation.time,
          vehicleTracker: location.trackerLocation.vehicleDetail.tracker,
          vehiclePlate: location.trackerLocation.vehicleDetail.plate,
          vehicleIgnition: location.trackerLocation.vehicleDetail.ignition,
          isAppLocation: false,
        });
      }
    })

    const selectedPosition = newLocationList.find(el => el.nfId === activeRow.id);
    const nfListGroup = groupBy(deliveryData, 'cpfMotorista');

    if (selectedPosition && mapRef) {
      const curPosition = new window.google.maps.LatLng(
        selectedPosition.latitude,
        selectedPosition.longitude,
      );

      this._setActiveNf({
        centerLat: curPosition.lat(),
        centerLng: curPosition.lng(),
        isVisible: true,
        lat: selectedPosition.latitude,
        lng: selectedPosition.longitude,
        landmark: selectedPosition.landmark,
        lastUpdate: selectedPosition.time,
        nfId: selectedPosition.nfId,
        data: nfListGroup[activeRow.cpfMotorista],
        expanded: nfListGroup[activeRow.cpfMotorista].findIndex(
          el => el.id === activeRow.id,
        ),
        zoom: 15,
      });
    }
  }

  _renderMarkerTooltip(e, location, newCenter, zoom = 15) {
    const activeRow = location.nfList && {
      nf: `${location.nfList[0].nf}-${location.nfList[0].nfGroup}`,
      nfValue: location.nfList[0].nfValue,
      client: location.nfList[0].destination.name,
      id: location.nfList[0].id,
    };

    this.setState(() => ({
      activeRow,
      mapCenter: {lat: e.latLng.lat(), lng: e.latLng.lng()},
    }));

    this._setActiveNf({
      centerLat: newCenter.lat(),
      centerLng: newCenter.lng(),
      isVisible: true,
      lat: e.latLng.lat(),
      lng: e.latLng.lng(),
      landmark: location.landmark,
      lastUpdate: location.time,
      nfId: location.nfList && location.nfList[0].id,
      data: location.nfList ? location.nfList : [],
      expanded: 0,
      isAppLocation: location.isAppLocation,
      zoom,
    });
  }

  _hideMarkerTooltip() {
    this.setState({
      activeNf: {
        isVisible: false,
      },
    });
  }

  _getNfLocationFromTable(row) {
    const { onTimeFiltered, lateRiskFiltered, lateFiltered } = this.props;
    const allNfs = [...onTimeFiltered, ...lateRiskFiltered, ...lateFiltered];

    const activeRow = allNfs.find(el => `${el.nf}-${el.nfGroup}` === row.nf);

    this.setState({
      activeRow: row,
    });
    
    this._getVehiclePosition(activeRow);
  }

  _changeMapExhibition(type) {
    this.setState({
      mapExhibition: type,
    });
  }

  render() {
    const { mapCenter, activeNf, activeRow, zoom, deliveryStatusActiveTab } = this.state;

    return (
      <div className="DashboardRealTime">
        <Map
          zoom={zoom}
          onZoomChanged={this._handleZoomChanged}
          googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyDNV7mHyjuTm0VC8ZZnW90OTZWrvBnXIaw&v=3.exp&libraries=geometry,drawing,places"
          loadingElement={<div className="DashboardRealTime__loading-el" />}
          containerElement={<div className="DashboardRealTime__container-el" />}
          mapElement={<div className="DashboardRealTime__map-el" />}
          deliveryStatusActiveTab={deliveryStatusActiveTab}
          mapCenter={mapCenter ?? { lat: -14.238962, lng: -51.913029 }}
          renderMarkerTooltip={this._renderMarkerTooltip}
          hideMarkerTooltip={this._hideMarkerTooltip}
          activeNf={activeNf}
          getPositionFromTracking={this._getPositionFromTracking}
          changeMapExhibition={this._changeMapExhibition}
          mapExhibition={this.state.mapExhibition}
          setMapRef={this._setMapRef}
          nfIdFromUrl={this.props.match?.params?.id}
        />
        <div className="DashboardRealTime__status">
          <DeliveryStatus
            onTabChange={this._changeTab}
            type={deliveryStatusTypes.ALL}
            collapsible
            storeKey={storeKeys.REAL_TIME}
            onGetNfLocationFromTable={this._getNfLocationFromTable}
            isModalOpen={activeNf && activeNf.isVisible}
            activeRow={activeRow}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    mapExhibition: state.dashboardRealTime.mapExhibition,
    onTime: state.dashboardRealTime.onTime.data,
    lateRisk: state.dashboardRealTime.lateRisk.data,
    late: state.dashboardRealTime.late.data,
    deliveryData: state.deliveryStatus.realTime.deliveries,
    onTimeFiltered: getDeliveryStatusDeliveriesByAccType(
      null,
      performanceStatus.ONTIME,
      storeKeys.REAL_TIME,
    )(state),
    lateRiskFiltered: getDeliveryStatusDeliveriesByAccType(
      null,
      performanceStatus.LATE_RISK,
      storeKeys.REAL_TIME,
    )(state),
    lateFiltered: getDeliveryStatusDeliveriesByAccType(
      null,
      performanceStatus.LATE,
      storeKeys.REAL_TIME,
    )(state),
  };
}

export default connect(mapStateToProps)(DashboardRealTime);
